/* src/app/dynamic-forms/form-view/form-view-text/form-view-text.component.scss */
.mat-mdc-form-field {
  overflow: auto;
  height: 100%;
}
textarea {
  height: 100% !important;
  overflow: auto;
}
:host ::ng-deep .customtextarea {
}
:host ::ng-deep .customtextarea .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea .mat-form-field-infix {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-wrapper {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-infix {
  height: 100% !important;
}
.customtextarea {
  height: 100%;
  width: 100%;
  position: relative;
}
/*# sourceMappingURL=form-view-text.component.css.map */
